import React from 'react';
import { weekDayMonthDay } from '../../../constants/dateStrings';
import { FULFILLMENT_TYPE } from '../../../constants/status';
import { ILineItem } from '../../../models/common';
import { ICardTrackingDetails } from '../../../models/purchase-history';
import TrackShipment from '../../order-details/track-shipment/TrackShipment';
import { dateFormat } from '../../order-details/util/format';
import { isLessThan90DaysBetweenDates } from '../../order-details/util/TrackingLogics';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';

export const CardTrackingDetails = ({
  item,
  orderStatus,
  orderNumber,
  date,
}: ICardTrackingDetails) => {
  const fulfillmentType = item?.fulfillmentType;

  const isLessThan90Days = isLessThan90DaysBetweenDates(
    new Date(),
    new Date(date),
  );

  const itemDate = dateFormat(
    (item?.shippingAndHandling?.applianceDeliveries?.[0]
      ?.currentDeliveryDate as string) ||
      (item?.shippingAndHandling?.estEndDeliveryDate as string) ||
      (item?.bodfsDeliveryAndHandling?.estEndDeliveryDate as string),
    weekDayMonthDay,
  );

  const hasGiftCard = item?.lineItems?.filter(
    (lineItem: ILineItem) => lineItem?.isGiftCard,
  ).length;

  return (
    <div className="sui-min-w-[190px] sui-max-w-[385px]">
      {!['InStorePurchase', 'InStore', 'MISC', 'unavailable'].includes(
        fulfillmentType,
      ) &&
        item?.lineItems?.length !== hasGiftCard && (
          <div className="sui-flex sui-flex-col sui-gap-4">
            {![
              'Canceled',
              'Returned',
              'Being Processed',
              'Ready For Pickup',
              'Complete',
              'On Schedule',
              '',
            ].includes(orderStatus ?? '') &&
              itemDate === 'Invalid Date, undefined' && (
                <AlertBanner status="error">
                  We were unable to retrieve your shipment details. Refresh the
                  page and try again.
                </AlertBanner>
              )}
            {![
              'Being Processed',
              'Returned',
              'Canceled',
              'Ready For Pickup',
              'Complete',
              '',
            ].includes(orderStatus ?? '') &&
              fulfillmentType !== 'BuyOnlinePickupInStore' &&
              isLessThan90Days && (
                <TrackShipment
                  buttonVariant="secondary"
                  orderId={orderNumber}
                  fulfillmentGroup={item}
                  fulfillmentType={fulfillmentType as FULFILLMENT_TYPE}
                  shipmentIndex={0}
                />
              )}
          </div>
        )}
    </div>
  );
};
